<template>
  <div class="TableOrderList">
    <!-- 保单列表  搜索有数据 -->
    <div class="hasData" v-if="isShow">
      <el-table
        empty-text=" "
        v-loading="loading"
        :data="list"
        stripe
        :row-class-name="TableRow"
        :header-cell-style="thClass"
        :cell-style="{ color: '#666666', height: '80px' }"
      >
        <el-table-column label="投保意向单编号" prop="orderSn" width="182px">
        </el-table-column>
        <el-table-column label="投保地块" width="172px">
          <template slot-scope="scope">
            {{ scope.row.farmInsureOrderLandCount }}个地块
            <span class="AcreMianJi">({{ scope.row.acre }}亩)</span>
          </template>
        </el-table-column>
        <el-table-column label="投保品种" width="182px">
          <template slot-scope="scope">
            <div class="multi-ellipsis--l2 noDunhaoFather">
              {{ scope.row.grainName }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="每亩可保产量">
          <template slot-scope="scope">
            {{ scope.row.numPerUnit ? scope.row.numPerUnit + "斤" : "-" }}
          </template>
        </el-table-column>
        <el-table-column label="预计保费">
          <template slot-scope="scope">
            {{
              scope.row.amountEstimate ? scope.row.amountEstimate + "元" : "-"
            }}
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100px">
          <template slot-scope="scope">
            <span :class="orderClolor[scope.row.orderStatus]">
              {{ setOrderS[scope.row.orderStatus] }}</span
            >
          </template>
        </el-table-column>

        <el-table-column label="提交时间" width="165px">
          <template slot-scope="scope">
            {{ scope.row.orderTime | formatDate("yyyy-MM-dd hh:mm:ss") }}
          </template>
        </el-table-column>

        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              class="button14"
              @click="checkContent(scope.row)"
              type="text"
              size="small"
              >查看</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 搜索后无数据 -->
    <div class="noDataImg" v-else>
      <div class="imgNo">
        <img src="~@/assets/images/insuranceImg/nodataImg.png" alt="" />
      </div>
      <p style="color: #333">未找到符合条件的数据</p>
    </div>
  </div>
</template>

<script>
import sameIn from "@/mixins/ruralListsdetails.js";

export default {
  name: "TableOrderList",
  mixins: [sameIn],
  data() {
    return {
      setOrderS: ["", "已提交", "已完成"],
      orderClolor: ["", "greenC", "greenC"],
    };
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    isShow: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    checkContent(row) {
      this.$router.push({
        name: "ruralDetailsIndex",
        query: {
          type: 2,
          id: row.id,
          cropId: Number(row.grainType),
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.hasData {
  height: 100%;
}
.tishiText {
  width: 200px;
}

.width230 {
  width: 230px;
}
.greenC {
  color: #11d8a0;
}
.huiColor {
  color: #888888;
}
</style>
